import {
  Box, Button, MenuItem, Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useListLiveProjectsQuery } from '../../../../../generated/core-api/graphql-react-query';
import useGlobalStoreContext from '../../../../Contexts/GlobalContext/Contexts/GlobalStoreContext/useGlobalStoreContext';
import EmptyProjectImage from './empty-svg.svg';
import StyledBox, { StyledMenu } from './styles';

export default function EmptyProjectWrapper({ children }: { children: React.ReactNode }) {
  const { projectId: [, setProjectId], rawProjectId } = useGlobalStoreContext();
  const projects = useListLiveProjectsQuery({});
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { t } = useTranslation();

  if (projects.data && !projects.data.listProjects.find((p) => p.id === rawProjectId)) {
    if (projects.data.listProjects.length === 0) {
      return (
        <StyledBox>
          <img src={EmptyProjectImage} alt="Empty Project" />
          <Typography variant="h5">{t('no-projects')}</Typography>
        </StyledBox>
      );
    }
    return (
      <StyledBox>
        <Typography variant="h5">{t('no-project-selected')}</Typography>
        <Box>
          <Button
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
            }}
            variant="contained"
          >
            {t('select-project-cta')}
          </Button>
          <StyledMenu
            anchorEl={anchorEl}
            open={!!anchorEl}
            onClose={() => { setAnchorEl(null); }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            {projects.data.listProjects.map((item) => (
              <MenuItem key={item.id} onClick={() => { setProjectId(item.id); }}>
                {item.name}
              </MenuItem>
            ))}
          </StyledMenu>
        </Box>
        <img src={EmptyProjectImage} alt="Empty Project" />
      </StyledBox>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
